
import React from 'react';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { IoMdInformationCircleOutline } from 'react-icons/io';

export default function TooltipsNew({ info, myPlacement }) {
    return (
        <>
            {['top'].map((placement) => (
                <OverlayTrigger
                    key={placement}
                    placement={myPlacement || 'top'}
                    overlay={
                        <Tooltip id={`tooltip-${placement}`}>
                            {info.split('\n').map((line, index) => (
                                <React.Fragment key={index}>
                                    {index === 0 ? <strong>{line}</strong> : line}
                                    {index < info.split('\n').length - 1 && <br />}
                                </React.Fragment>
                            ))}
                        </Tooltip>
                    }
                >
                    <Button
                        className="InfoIcon"
                        style={{ margin: '0px' }}
                        variant="secondary"
                    >
                        <IoMdInformationCircleOutline />
                    </Button>
                </OverlayTrigger>
            ))}
        </>
    );
}
